import * as types from "../../mutation-types";

export default {
  [types.GET_BUSINESS_TYPE](state, data) {
    state.business_types = data;
  },
};
